import { useMemo } from 'react';
import { useNotificationContext } from '@context/NotificationsContext';
import { NOTIFICATION_NAMES_MAP } from '@utils/constants';

/**
 * Señal única de "cede el paso": ¿hay un pedido entrante en pantalla?
 *
 * Eleva a un hook reutilizable el MISMO filtro que NotificationCenterV2.tsx:116
 * (`notifications.filter(n => n.id.endsWith(NOTIFICATION_NAMES_MAP.INCOMING_ORDER.key))`)
 * para que toda la UI de Paulina (pill, sheet, dot proactivo) se gatee por una
 * sola fuente de verdad. Lo OPERATIVO (pedidos) siempre gana: cuando `hayPedido`
 * es true, las superficies de Paulina deben suprimirse para no tapar el toast de
 * pedido (z-99 en NotificationCenterV2).
 *
 * El selector va MEMOIZADO: solo recalcula cuando cambia el array `notifications`,
 * no en cada render del consumidor.
 */
export interface PaulinaShouldYield {
  hayPedido: boolean;
}

export const usePaulinaShouldYield = (): PaulinaShouldYield => {
  const { notifications } = useNotificationContext();

  const hayPedido = useMemo(
    () => notifications.filter((n) => n.id.endsWith(NOTIFICATION_NAMES_MAP.INCOMING_ORDER.key)).length > 0,
    [notifications],
  );

  return { hayPedido };
};
